import type { ValidationState } from "interfaces/validation-state";

const ValueRequiredState: ValidationState = {
    validationMessage: "Value is required.",
    isInvalid: true,
};

export { ValueRequiredState };
